import styled from 'styled-components';

/**
 * Área clicável do collapse.
 * No mobile preenche o quadrado opaco do HeaderLeftBar.
 */
export const CollapseTriggerWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 8px;
  border-radius: 6px;
  transition: background 0.2s ease;
  position: relative;
  z-index: 2;
  user-select: none;

  ${({ $preencheArea }) =>
    $preencheArea &&
    `
    width: 100%;
    height: 100%;
    padding: 0;
    border-radius: inherit;
  `}

  .collapse-icon,
  .collapse-icon svg {
    pointer-events: none;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.12);
  }

  &:focus {
    outline: 2px solid rgba(255, 255, 255, 0.8);
    outline-offset: 2px;
  }
`;
